// extracted by css-extract-rspack-plugin
export default {"container":"muFRP","narrow_hidden":"cfyGN","narrowHidden":"cfyGN"};